// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-bubble';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm6.25 12.5a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5Zm7 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Zm-4-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm7.5-4.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5Z' />
);

export const viewBox = '0 0 22 22';
